import { AiFillUnlock } from 'react-icons/ai';
import { LockIcon } from '../../../icons/LockIcon';
import { isRetailConfiguratorPage } from '../ProductBuilderComponents/commonHelper';
import { isRetailAutomation } from '../../../Configurator/utils';

export const Lock = ({ active, className, color, onClick }) => {
  const isRetail = isRetailConfiguratorPage() || isRetailAutomation()
  return active ? (
    <LockIcon className={className} color={color || '#A3A4A6'} onClick={onClick} />
  ) : (
    <AiFillUnlock
      className={className}
      onClick={onClick}
      color={isRetail ? 'currentColor' : color || '#fff'}
      style={{ fontSize: 24 }}
    />
  );
};
